import React from "react";
import { Box, Grid, Step, StepLabel, Stepper } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import WhatsMyTaxNumberForm from "./Components/Pages/WhatsMyTaxNumberForm";
import TRNSearchResultsForm from "./Components/Pages/TRNSearchResultsForm";
import Confirmation from "./Components/Confirmation";
import RegisterForTaxNumberForm from "./Components/Pages/RegisterForTaxNumberForm";
import {
  cancelVerification,
  clearErrors,
  currentPage,
  errors,
  getDropdownData,
  isLoading,
  getPrepopDataAsync,
  setPageReg,
  isKiosk,
  skipCaptcha
} from "./features/trnAppSlice";
import { SARSHeader, ErrorModal ,YoutubeEmbed} from "@soqs/common";
import { useEffect } from "react";
import Captcha from "./Components/Captcha";
import { LinearProgress } from "@mui/material";
import { getVideo } from "./features/API";

export const PAGES = {
  WhatsMyTaxNumberForm: 0,
  RegisterForTaxNumberForm: 1,
  Captcha: 2,
  TRNSearchResultsForm: 3,
  Confirmation: 4,
};

function App() {
  const token = new URLSearchParams(window.location.search).get("token");
  const dispatch = useDispatch();
  const pageState = useSelector(currentPage);
  const errorState = useSelector(errors);
  const loading = useSelector(isLoading);
  const urlPath = window.location.href;
  const querytype = new URLSearchParams(window.location.search).get(
    "querytype"
  );
  const kiosk = useSelector(isKiosk);
  const skipcaptcha = useSelector(skipCaptcha);

  useEffect(
    () => {
      dispatch(getDropdownData());
      if (urlPath.includes("pitregistration")) {
        dispatch(setPageReg());
      }
      //   else {
      //     dispatch(getPrepopDataAsync(kiosktoken));
      //   };
      if (token) {
        dispatch(getPrepopDataAsync(token + "|" + querytype));
      }

      return () => {};
    }, 
    []
  );

  const Pager = (props) => {
    switch (props.page) {
      case PAGES.WhatsMyTaxNumberForm:
        if (token && loading) {
          return <LinearProgress />;
        }
        return <WhatsMyTaxNumberForm />;
      case PAGES.Captcha:
        return <Captcha />;
      case PAGES.TRNSearchResultsForm:
        return <TRNSearchResultsForm />;
      case PAGES.Confirmation:
        return <Confirmation />;
      case PAGES.RegisterForTaxNumberForm:
        if (token && loading) {
          return <LinearProgress />;
        }
        return <RegisterForTaxNumberForm />;
      default: {
        dispatch(
          cancelVerification({
            targetPage: PAGES.WhatsMyTaxNumberForm,
          })
        );
        break;
      }
    }
  };

  const getStepFromPage = (page) => {
    if (urlPath.includes("pitregistration")) {
      switch (page) {
        case PAGES.RegisterForTaxNumberForm:
          return 0;
        case PAGES.Captcha:
          return 1;
        case PAGES.Confirmation:
            if (kiosk && skipcaptcha) return 1;
          if (kiosk && !skipcaptcha) return 2;
          if (!kiosk) return 2;
          break;
        default:
          return 0;
      }
    } else {
      switch (page) {
        case PAGES.WhatsMyTaxNumberForm:
          return 0;
        case PAGES.Captcha:
          return 1;
         case PAGES.TRNSearchResultsForm:
          if (kiosk && skipcaptcha) return 1;
          if (kiosk && !skipcaptcha) return 2;
          if (!kiosk) return 2; 
          break;
        case PAGES.Confirmation:
           if (kiosk && skipcaptcha) return 2;
          if (kiosk && !skipcaptcha) return 3;
          if (!kiosk) return 3; 
          break;
        default:
          return 0;
      }
    }
  };

  const StepperWrapper = ({ page }) => (
    <>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        {urlPath.includes("pitregistration") ? (
          <Stepper activeStep={getStepFromPage(page)}>
            <Step
              key={PAGES.RegisterForTaxNumberForm}
              completed={pageState > PAGES.RegisterForTaxNumberForm}
            >
              <StepLabel>Enter Registration Details</StepLabel>
            </Step>
            {(!kiosk || !skipcaptcha) ? (
              <Step key={PAGES.Captcha} completed={pageState > PAGES.Captcha}>
                <StepLabel>Captcha</StepLabel>
              </Step>
            ) : null}
            <Step
              key={PAGES.Confirmation}
              completed={pageState > PAGES.Confirmation}
            >
              <StepLabel>Confirmation</StepLabel>
            </Step>
          </Stepper>
        ) : (
          <Stepper activeStep={getStepFromPage(page)}>
            <Step
              key={PAGES.WhatsMyTaxNumberForm}
              completed={pageState > PAGES.WhatsMyTaxNumberForm}
            >
              <StepLabel>Enter Your Details</StepLabel>
            </Step>
             {(!kiosk  || !skipcaptcha) ? (
              <Step key={PAGES.Captcha} completed={pageState > PAGES.Captcha}>
                <StepLabel>Captcha</StepLabel>
              </Step>
            ) : (
              ""
            )}
            <Step
              key={PAGES.TRNSearchResultsForm}
              completed={pageState > PAGES.TRNSearchResultsForm}
            >
              <StepLabel>Search Results</StepLabel>
            </Step>
            <Step
              key={PAGES.Confirmation}
              completed={pageState > PAGES.Confirmation}
            >
              <StepLabel>Confirmation</StepLabel>
            </Step>
          </Stepper>
        )}
      </Box>
    </>
  );

  return (
    <>
      <SARSHeader
        onLogoClick={() => {
          window.location.reload(false);
          dispatch(
            cancelVerification({
              targetPage: urlPath.includes("pitregistration")
                ? PAGES.RegisterForTaxNumberForm
                : PAGES.WhatsMyTaxNumberForm,
            })
          );
        }}
        pageTitle={
          urlPath.includes("pitregistration")
            ? "Register for Personal Income Tax"
            : "What's My Tax Reference Number"
        }
      />

      <div className="App">
        <Grid
          container
          spacing={2}
          style={{
            minHeight: "80vh",
            paddingLeft: "2%",
            paddingRight: "2%",
            justifyContent: "center",
          }}
          alignContent="flex-start"
        >
          <Grid
            size={{ xs: 12 }}
            style={{ paddingTop: "4vh", maxWidth: "1500px" }}
          >
            <StepperWrapper page={pageState} />
          </Grid>
          <Grid size={{ xs: 12 }} style={{ maxWidth: "1500px" }}>
            <Pager page={pageState} />
            <ErrorModal
              title={
                errorState?.errortitle
                  ? errorState?.errortitle
                  : typeof errorState?.error === "string" &&
                      errorState?.error?.indexOf("|") > -1
                    ? errorState?.error?.split("|")[0]
                    : "Error"
              }
              open={errorState !== null}
              onClose={() => {
                if (errorState?.fatal) {
                  dispatch(
                    cancelVerification({
                      targetPage: urlPath.includes("pitregistration")
                        ? PAGES.RegisterForTaxNumberForm
                        : PAGES.WhatsMyTaxNumberForm,
                    })
                  );
                } else {
                  dispatch(clearErrors());
                }
              }}
              subheader={
                Array.isArray(errorState?.error) ? (
                  <ul>
                    {errorState?.error.map((e, idx) => (
                      <li key={idx}>{e.replace("- ", "")}</li>
                    ))}
                  </ul>
                ) : (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        errorState?.error?.indexOf("|") > -1
                          ? errorState?.error?.split("|")[1]
                          : errorState?.error,
                    }}
                  ></p>
                )
              }
            />
          </Grid>
        </Grid>

        <YoutubeEmbed
          appCode={new URLSearchParams(window.location.search).get("querytype") === "pitregistration" ? "WMTRN_REG" : "WMTRN"}
          fetchVideo={getVideo}
          initialPosition="top-right"
        />
      </div>
    </>
  );
}

export default App;
